import { Flex } from 'reflexbox';
import { toast } from 'react-toastify';
import { AssetStatus } from '~/components/AssetStatus';
import {
  Button, Card,
  Loader,
} from '~/components';
import {
  Title,
  CustomInput,
  Label,
} from './styles';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { useTranslation } from 'react-i18next';
import { useStateVar } from 'helpers/useStateVar';
import { colors } from '~/styles/colors';
import { useEffect } from 'react';
import { apiCall } from '~/providers';
import { DevFullInfo } from '~/store';
import { getCachedDevInfo } from '~/helpers/cachedStorage';

export const EditDmtSelectClient = ({ dmtInfo, renderDevInfo }): JSX.Element => {
  const { t } = useTranslation();
  const [state, render, setState] = useStateVar({
    loading: false,
    devId: dmtInfo.DEV_ID,
    devInfo: null as null|DevFullInfo,
    dmtInfo,
    clientsOpts: [] as { name: string, value: number|string }[],
    selectedClient: null as any,
    unitsOpts: [] as { name: string, value: number|string, STATE_ID?: number, STATE_NAME?: string, CITY_NAME?: string, UNIT_NAME?: string, CLIENT_NAME?: string }[],
    selectedUnit: null as any,
    mobile: window.innerWidth < 650,
  });

  const getClientsOpts = async () => {
    setState({ loading: true });
    try {
      const { list: clients } = await apiCall('/clients/get-clients-list', {});
      state.clientsOpts = clients.map((client) => ({ name: client.NAME, value: client.CLIENT_ID }));
      render();
    } catch (error) {
      toast.error(t('erroAoCarregarClientes'));
    }
    setState({ loading: false });
  };

  const getUnitOpts = async () => {
    setState({ loading: true });
    try {
      const units = await apiCall('/clients/get-units-list', { CLIENT_ID: state.selectedClient });
      state.unitsOpts = units.map((units) => ({
        name: units.UNIT_NAME, value: units.UNIT_ID, STATE_ID: units.STATE_ID, CLIENT_NAME: units.CLIENT_NAME, UNIT_NAME: units.UNIT_NAME, CITY_NAME: units.CITY_NAME,
      }));
      if (!units.length) {
        toast.info(t('nenhumaUnidadeEncontrada'));
      }
      render();
    } catch (error) {
      toast.error(t('erroAoCarregarUnidades'));
    }
    setState({ loading: false });
  };

  useEffect(() => {
    getClientsOpts();
  }, []);

  useEffect(() => {
    if (state.selectedClient) {
      getUnitOpts();
    }
  }, [state.selectedClient]);

  async function saveDmtInfo() {
    setState({ loading: true });
    try {
      await apiCall('/dmt/set-dmt-utilities', {
        DMT_CODE: state.devId,
        UNIT_ID: state.selectedUnit,
        utilities: [],
      });
      state.devInfo = await getCachedDevInfo(state.devId, { forceFresh: true });
      renderDevInfo(state.devInfo);
      toast.success(t('sucessoSalvar'));
    } catch (err) {
      console.log(err);
      toast.error(t('erroSalvarInfo'));
    }
    setState({ loading: false });
  }

  return (
    <Card>
      <Flex flexDirection="row" width="100%" marginTop="10px" flexWrap="wrap" justifyContent="space-between" fontSize="13px" padding="20px">
        <Flex width="100%" flexDirection="column" flex="wrap">
          <HeaderInfoDevice state={state} t={t} />
          <Flex mb="10px" mt="20px" flexWrap="wrap" flexDirection="column">

            <Title>{t('informacoes')}</Title>
            {
              state.loading ? <Loader /> : (
                <div
                  style={{
                    display: 'flex', flexDirection: 'row', width: '100%', gap: '20px', alignItems: 'center', flexWrap: 'wrap',
                  }}
                >
                  <CustomInput style={{ marginBottom: '20px', width: 224 }}>
                    <div style={{ paddingTop: 3, width: '100%', zIndex: 3 }}>
                      <Label>{`${t('cliente')}*`}</Label>
                      <SelectSearch
                        filterOptions={fuzzySearch}
                        closeOnSelect
                        placeholder={t('selecioneCliente')}
                        value={state.selectedClient}
                        options={state.clientsOpts}
                        onChange={(item) => { state.selectedClient = item; state.unitsOpts = []; render(); }}
                        disabled={!state.clientsOpts.length}
                        search
                      />
                    </div>
                  </CustomInput>
                  <CustomInput style={{ marginBottom: '20px', width: 224 }}>
                    <div style={{ paddingTop: 3, width: '100%', zIndex: 2 }}>

                      <Label>{`${t('unidade')}*`}</Label>
                      <SelectSearch
                        filterOptions={fuzzySearch}
                        options={state.unitsOpts}
                        closeOnSelect
                        placeholder={t('selecioneUnidade')}
                        value={state.selectedUnit}
                        onChange={(item) => { state.selectedUnit = item; render(); }}
                        disabled={!state.selectedClient || !state.unitsOpts.length}
                        search
                      />
                    </div>
                  </CustomInput>
                  <div style={{ marginBottom: '20px' }}>
                    <Button
                      variant={(!state.selectedClient || !state.selectedUnit) ? 'disabled' : 'primary'}
                      style={{ width: 114 }}
                      onClick={() => { saveDmtInfo(); }}
                    >
                      {t('salvar')}
                    </Button>
                  </div>
                </div>
              )
            }
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};

export const HeaderInfoDevice = ({ state, t }): JSX.Element => (
  <Flex flexWrap={state.mobile ? 'wrap' : 'nowrap'} style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
    <Flex flexDirection="column" mb={state.mobile ? '10px' : 0}>
      <span style={{ fontWeight: 600, fontSize: '18px', lineHeight: '14px' }}>{t('editarDispositivo')}</span>
      <span style={{ fontSize: '14px', color: colors.text['sub-500'], marginTop: 5 }}>{state.devId}</span>
    </Flex>

    <AssetStatus
      isAutomation
      withoutMarginTop
      DUT_ID={null}
      DEV_ID={state.devId}
      DEV_AUT={state.devId}
      key={state.devId}
    />
  </Flex>
);
